(function () {
  'use strict';

  function initCatalog(root) {
    var dataEl = root.querySelector('script[data-kw-products]');
    var configEl = root.querySelector('script[data-kw-facet-config]');
    if (!dataEl || !configEl) return;

    var products;
    var config;
    try {
      products = JSON.parse(dataEl.textContent);
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var sidebarInner = root.querySelector('[data-kw-sidebar-inner]');
    var sidebar = root.querySelector('[data-kw-sidebar]');
    var grid = root.querySelector('[data-kw-grid]');
    var emptyEl = root.querySelector('[data-kw-empty]');
    var countEl = root.querySelector('[data-kw-count]');
    var sortSelect = root.querySelector('[data-kw-sort]');
    var paginationEl = root.querySelector('[data-kw-pagination]');
    var clearBtn = root.querySelector('[data-kw-clear]');
    var filterToggle = root.querySelector('[data-kw-filter-toggle]');
    var cardTemplate = root.querySelector('[data-kw-card-template]');

    var PER_PAGE = 24;

    // Active filter state: { groupKey: Set(values) }, plus price min/max
    var state = {
      selections: {},
      priceMin: null,
      priceMax: null,
      sort: 'title-asc',
      page: 1
    };

    // ---- Build dynamic facet groups (grape list, vintage) from data ----
    var groups = config.groups.slice();

    if (config.showVintage) {
      groups.push({ key: 'vintage', label: 'Vintage', kind: 'list-number' });
    }

    groups.forEach(function (g) {
      if (g.kind === 'list' || g.kind === 'list-number') {
        var set = {};
        products.forEach(function (p) {
          var val = g.key === 'vintage' ? p.vintage : p.grape;
          if (val === null || val === undefined) return;
          var arr = Array.isArray(val) ? val : [val];
          arr.forEach(function (v) {
            if (v === null || v === undefined || v === '') return;
            set[v] = true;
          });
        });
        var values = Object.keys(set);
        if (g.kind === 'list-number') {
          values.sort(function (a, b) { return Number(a) - Number(b); });
        } else {
          values.sort(function (a, b) { return a.localeCompare(b); });
        }
        g.values = values;
      }
    });

    groups.forEach(function (g) { state.selections[g.key] = new Set(); });

    // ---- Pre-select filters from URL query params, e.g. ?region=Northern%20Greece ----
    // Lets other pages (like the homepage region map) link straight into a
    // pre-filtered view of the catalog. Supports comma-separated multiple values.
    var urlParams = new URLSearchParams(window.location.search);
    groups.forEach(function (g) {
      var raw = urlParams.get(g.key);
      if (!raw) return;
      raw.split(',').forEach(function (v) {
        var val = decodeURIComponent(v).trim();
        if (val) state.selections[g.key].add(val);
      });
    });

    // ---- Which groups are expanded on first render ----
    // A plain visit to the catalog opens every group. Arriving via the homepage
    // "Vegan, Biodynamic, Organic, Natural" tile (which pre-selects the Special
    // filter via ?special=...) instead opens only Type, Region and Special, and
    // leaves Grape, Vintage and Price collapsed - those aren't relevant to that
    // entry point. Keyed off the presence of the "special" URL param so it
    // applies to that link (and any future link built the same way) without
    // needing to know the exact values requested.
    var defaultOpenKeys = urlParams.get('special') ? ['type', 'region', 'special'] : null;
    function isGroupOpenByDefault(key) {
      return defaultOpenKeys === null || defaultOpenKeys.indexOf(key) !== -1;
    }

    // ---- Matching logic ----
    function productMatchesGroup(p, group) {
      var sel = state.selections[group.key];
      if (!sel || sel.size === 0) return true;

      if (group.kind === 'tag') {
        var tags = p.tags || [];
        for (var v of sel) { if (tags.indexOf(v) !== -1) return true; }
        return false;
      }
      if (group.kind === 'list') {
        var arr = p.grape;
        if (!arr) return false;
        var list = Array.isArray(arr) ? arr : [arr];
        for (var v2 of sel) { if (list.indexOf(v2) !== -1) return true; }
        return false;
      }
      if (group.kind === 'list-number') {
        if (p.vintage === null || p.vintage === undefined) return false;
        for (var v3 of sel) { if (String(p.vintage) === String(v3)) return true; }
        return false;
      }
      if (group.kind === 'range') {
        var abv = p.abv;
        if (abv === null || abv === undefined) return false;
        for (var v4 of sel) {
          var bucket = group.buckets.filter(function (b) { return b.label === v4; })[0];
          if (bucket && abv >= bucket.min && abv < bucket.max) return true;
        }
        return false;
      }
      return true;
    }

    function productMatchesPrice(p) {
      if (state.priceMin !== null && p.priceRaw < state.priceMin) return false;
      if (state.priceMax !== null && p.priceRaw > state.priceMax) return false;
      return true;
    }

    function productMatchesAllExcept(p, exceptKey) {
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        if (g.key === exceptKey) continue;
        if (!productMatchesGroup(p, g)) return false;
      }
      if (exceptKey !== 'price' && !productMatchesPrice(p)) return false;
      return true;
    }

    function getFiltered() {
      return products.filter(function (p) {
        for (var i = 0; i < groups.length; i++) {
          if (!productMatchesGroup(p, groups[i])) return false;
        }
        if (!productMatchesPrice(p)) return false;
        return true;
      });
    }

    // ---- Count helper: how many products would match if this option were added ----
    function countForOption(group, value) {
      var base = products.filter(function (p) { return productMatchesAllExcept(p, group.key); });
      return base.filter(function (p) {
        if (group.kind === 'tag') return (p.tags || []).indexOf(value) !== -1;
        if (group.kind === 'list') {
          var arr = p.grape;
          var list = Array.isArray(arr) ? arr : (arr ? [arr] : []);
          return list.indexOf(value) !== -1;
        }
        if (group.kind === 'list-number') return String(p.vintage) === String(value);
        if (group.kind === 'range') {
          var bucket = group.buckets.filter(function (b) { return b.label === value; })[0];
          return bucket && p.abv !== null && p.abv !== undefined && p.abv >= bucket.min && p.abv < bucket.max;
        }
        return false;
      }).length;
    }

    // ---- Render sidebar ----
    function renderSidebar() {
      sidebarInner.innerHTML = '';
      groups.forEach(function (group, idx) {
        var wrap = document.createElement('div');
        wrap.className = 'kw-filter-group';
        wrap.setAttribute('data-open', isGroupOpenByDefault(group.key) ? 'true' : 'false');

        var head = document.createElement('button');
        head.type = 'button';
        head.className = 'kw-filter-group__head';
        head.textContent = group.label;
        head.addEventListener('click', function () {
          var open = wrap.getAttribute('data-open') === 'true';
          wrap.setAttribute('data-open', open ? 'false' : 'true');
        });
        wrap.appendChild(head);

        var body = document.createElement('div');
        body.className = 'kw-filter-group__body';

        var values = group.kind === 'range' ? group.buckets.map(function (b) { return b.label; }) : group.values;
        (values || []).forEach(function (value) {
          var count = countForOption(group, value);
          var label = document.createElement('label');
          label.className = 'kw-filter-option';
          label.setAttribute('data-zero', count === 0 && !state.selections[group.key].has(value) ? 'true' : 'false');

          var input = document.createElement('input');
          input.type = 'checkbox';
          input.checked = state.selections[group.key].has(value);
          input.addEventListener('change', function () {
            if (input.checked) state.selections[group.key].add(value);
            else state.selections[group.key].delete(value);
            state.page = 1;
            renderAll();
          });

          var span = document.createElement('span');
          span.className = 'kw-filter-option__label';
          span.appendChild(input);
          span.appendChild(document.createTextNode(value));

          var countSpan = document.createElement('span');
          countSpan.className = 'kw-filter-option__count';
          countSpan.textContent = count;

          label.appendChild(span);
          label.appendChild(countSpan);
          body.appendChild(label);
        });

        wrap.appendChild(body);
        sidebarInner.appendChild(wrap);
      });

      if (config.showPrice) {
        var priceWrap = document.createElement('div');
        priceWrap.className = 'kw-filter-group';
        priceWrap.setAttribute('data-open', isGroupOpenByDefault('price') ? 'true' : 'false');

        var priceHead = document.createElement('button');
        priceHead.type = 'button';
        priceHead.className = 'kw-filter-group__head';
        priceHead.textContent = 'By Price';
        priceHead.addEventListener('click', function () {
          var open = priceWrap.getAttribute('data-open') === 'true';
          priceWrap.setAttribute('data-open', open ? 'false' : 'true');
        });
        priceWrap.appendChild(priceHead);

        var priceBody = document.createElement('div');
        priceBody.className = 'kw-filter-group__body';
        priceBody.style.display = priceWrap.getAttribute('data-open') === 'true' ? 'flex' : 'none';

        var priceRow = document.createElement('div');
        priceRow.className = 'kw-filter-price';

        var minInput = document.createElement('input');
        minInput.type = 'number';
        minInput.placeholder = 'MIN';
        minInput.value = state.priceMin !== null ? state.priceMin : '';

        var maxInput = document.createElement('input');
        maxInput.type = 'number';
        maxInput.placeholder = 'MAX';
        maxInput.value = state.priceMax !== null ? state.priceMax : '';

        var searchBtn = document.createElement('button');
        searchBtn.type = 'button';
        searchBtn.textContent = 'SEARCH';
        searchBtn.addEventListener('click', function () {
          state.priceMin = minInput.value !== '' ? Number(minInput.value) : null;
          state.priceMax = maxInput.value !== '' ? Number(maxInput.value) : null;
          state.page = 1;
          renderAll();
        });

        priceRow.appendChild(minInput);
        priceRow.appendChild(maxInput);
        priceRow.appendChild(searchBtn);
        priceBody.appendChild(priceRow);
        priceWrap.appendChild(priceBody);

        // fix toggle to also control display since this group built separately
        priceHead.addEventListener('click', function () {
          priceBody.style.display = priceWrap.getAttribute('data-open') === 'true' ? 'flex' : 'none';
        });

        sidebarInner.appendChild(priceWrap);
      }

      var anyActive = Object.keys(state.selections).some(function (k) { return state.selections[k].size > 0; }) ||
        state.priceMin !== null || state.priceMax !== null;
      clearBtn.hidden = !anyActive;
    }

    // ---- Render grid + pagination ----
    function renderGrid() {
      var filtered = getFiltered();

      // sort
      var sorted = filtered.slice();
      if (state.sort === 'title-asc') sorted.sort(function (a, b) { return a.title.localeCompare(b.title, 'en', { sensitivity: 'base', numeric: true }); });
      else if (state.sort === 'price-asc') sorted.sort(function (a, b) { return a.priceRaw - b.priceRaw; });
      else if (state.sort === 'price-desc') sorted.sort(function (a, b) { return b.priceRaw - a.priceRaw; });

      countEl.textContent = filtered.length;
      emptyEl.hidden = filtered.length !== 0;
      grid.style.display = filtered.length === 0 ? 'none' : 'grid';

      var totalPages = Math.max(1, Math.ceil(sorted.length / PER_PAGE));
      if (state.page > totalPages) state.page = totalPages;
      var startIdx = (state.page - 1) * PER_PAGE;
      var pageItems = sorted.slice(startIdx, startIdx + PER_PAGE);

      grid.innerHTML = '';
      pageItems.forEach(function (p) {
        var node = cardTemplate.content.cloneNode(true);
        var link = node.querySelector('[data-kw-card-link]');
        var img = node.querySelector('[data-kw-card-img]');
        var titleLink = node.querySelector('[data-kw-card-title-link]');
        var priceEl = node.querySelector('[data-kw-card-price]');

        link.href = p.url;
        if (p.image) { img.src = p.image; img.alt = p.title; }
        titleLink.href = p.url;
        titleLink.textContent = p.title;
        priceEl.textContent = p.price;

        grid.appendChild(node);
      });

      renderPagination(totalPages);
    }

    function renderPagination(totalPages) {
      paginationEl.innerHTML = '';
      if (totalPages <= 1) return;

      function makeBtn(label, page, disabled, current) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = label;
        b.disabled = !!disabled;
        if (current) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', function () {
          state.page = page;
          renderGrid();
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        return b;
      }

      paginationEl.appendChild(makeBtn('‹', Math.max(1, state.page - 1), state.page === 1, false));

      for (var i = 1; i <= totalPages; i++) {
        if (totalPages > 7 && i > 3 && i < totalPages - 1 && Math.abs(i - state.page) > 1) {
          if (i === 4 || i === totalPages - 2) {
            var dots = document.createElement('span');
            dots.textContent = '...';
            dots.style.padding = '0 4px';
            paginationEl.appendChild(dots);
          }
          continue;
        }
        paginationEl.appendChild(makeBtn(String(i), i, false, i === state.page));
      }

      paginationEl.appendChild(makeBtn('›', Math.min(totalPages, state.page + 1), state.page === totalPages, false));
    }

    function renderAll() {
      renderSidebar();
      renderGrid();
    }

    sortSelect.addEventListener('change', function () {
      state.sort = sortSelect.value;
      state.page = 1;
      renderGrid();
    });

    clearBtn.addEventListener('click', function () {
      groups.forEach(function (g) { state.selections[g.key] = new Set(); });
      state.priceMin = null;
      state.priceMax = null;
      state.page = 1;
      renderAll();
    });

    var mobileFilters = window.matchMedia('(max-width: 749px)');
    var closeButtons = sidebar.querySelectorAll('[data-kw-filter-close]');
    var savedOverflow = null;
    function setFiltersOpen(open, restoreFocus) {
      sidebar.setAttribute('data-open', open ? 'true' : 'false');
      filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        savedOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        closeButtons[0].focus();
      } else {
        if (savedOverflow !== null) document.documentElement.style.overflow = savedOverflow;
        savedOverflow = null;
        if (restoreFocus) filterToggle.focus();
      }
    }
    if (filterToggle) {
      filterToggle.addEventListener('click', function () {
        setFiltersOpen(sidebar.getAttribute('data-open') !== 'true', true);
      });
      closeButtons.forEach(function (button) {
        button.addEventListener('click', function () { setFiltersOpen(false, true); });
      });
      sidebar.addEventListener('keydown', function (event) {
        if (!mobileFilters.matches || sidebar.getAttribute('data-open') !== 'true') return;
        if (event.key === 'Escape') {
          event.preventDefault();
          setFiltersOpen(false, true);
        }
        if (event.key === 'Tab') {
          var focusable = Array.from(sidebar.querySelectorAll('button, input, select, a[href]')).filter(function (el) {
            return !el.disabled && el.getClientRects().length;
          });
          var first = focusable[0], last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault(); last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault(); first.focus();
          }
        }
      });
      mobileFilters.addEventListener('change', function () { setFiltersOpen(false, false); });
    }

    renderAll();
  }

  function init() {
    document.querySelectorAll('.kw-catalog').forEach(initCatalog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
